<template>
    <el-form size="mini" :model="form" :inline=true>
        <el-form-item label="申请时间">
            <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="开始日期" style="width: 180px">
            </el-date-picker>
            <span class="split">-</span>
            <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束日期" style="width: 180px">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="患者姓名">
            <el-input v-model="form.patName" placeholder="患者姓名"></el-input>
        </el-form-item>
        <el-form-item label="预约医院">
            <el-select v-model="form.bookHosId">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(data,index) in hopeHosIds" :key="index" :label="data.hosName"
                           :value="data.consultGroupHosId"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
            <el-button type="success" @click="query">查询</el-button>
            <el-button type="primary" @click="apply">发起远程门诊</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import {getLastTime} from '../../lib/hos/until';
    import {consultationService} from "../../lib/service/consultation";
    export default {
        name: "dis-search-from",
        data(){
            return {
                form:{
                    startDate:'',
                    endDate:'',
                    patName:'',
                    bookHosId:''
                },
                hopeHosIds:[],//医院
            }
        },
        methods:{
            getForm(){
                return this.form;
            },
            //设置默认时间
            setDefalutTime(){
                const timeObj = getLastTime(10);
                this.form.endDate = timeObj.start;
                this.form.startDate = timeObj.end;
            },
            apply(){
               this.$router.push({path:"/main/registration",query:{
                    from:"distance"
               }})
            },
            //预约医院
            async hopeHosList(){
                this.hopeHosIds = await consultationService.groupHosList(this.docInfo.hosId);
            },
            query(){
                this.$emit('query');
            }
        },
        created(){
            this.setDefalutTime();
            this.hopeHosList();
        },
        mounted() {
            this.$emit('queryData');
        }
    }
</script>

<style scoped>
    .split{
        margin: 0 10px;
        color:#999999
    }
</style>